export default __webpack_public_path__ + "static/media/banner_5.0795fa10.jpg";